import { IStudyDetails } from './study-details.entity';
import { projectStudyIncomingDtoSchema } from '@core/services/study-table/study-table.effects';
import { defaultEntityState } from '@core/state/entities/entity';
import { normalizeAndMergeEntity } from '@core/state/entities/entity.helpers';
import { createReducer, on } from '@ngrx/store';
import { studiesActions } from '@core/actions/studies.actions';
import { entityKey } from '@core/state/entities/entity-name-map';

export const studyDetailsEntityReducer = createReducer(
  defaultEntityState<IStudyDetails>(),
  on(studiesActions.studyListUpdated, (state, props) =>
    normalizeAndMergeEntity(
      entityKey.studyDetails,
      state,
      props,
      projectStudyIncomingDtoSchema
    )
  )
);
